import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios';
import { BASE_URL } from '../Config/Base';
import { ToastContainer, toast } from 'react-toastify';
import { Oval } from 'react-loader-spinner'

const Corpsectionmain = () => {

  const token = JSON.parse(localStorage.getItem('usertoken'));
  const[pop,setpop] = useState(false);

  useEffect(()=>{
    document.getElementById('Corp-sectionMainA').style.display = "none";
    document.getElementById('CorpLableSection').style.display = "none";
   setpop(true);
    Getusers();
    getContent();
    getGBContent();
    getRoleData()
   SelectParticular();
    setTimeout(()=>{
      
     getresult();
     
    },1000)

    setTimeout(()=>{
      setpop(false);
      document.getElementById('Corp-sectionMainA').style.display = "inline";
    },2000)
  },[])


  

  function Getusers(){
  console.log("Token",token)

    fetch(`${BASE_URL}/Kdpcorp/GetCorpAssignUser`,{

      method:"GET",
      headers:{
        "Content-type": "application/json",

        "Accept": "application/json",
  
        "Authorization": "Bearer " + `${token}`,
  
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
      },
         //body:JSON.stringify(data)

    }).then(response=> response.json())
    .then(data=>{
      console.log("Data",data)
      localStorage.setItem("Data", JSON.stringify(data));
      
    });
    // console.log("check",allusers)
  }


  function getRoleData(){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   let UserRole =  localStorage.getItem("Role");
  
   const body ={
    
    role:UserRole
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       url: `${BASE_URL}/Kdpcorp/GetCorpLoginUserRole`,      
      //  url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
      
       }) ;


     
      }
  //SelectParticular

 
  var UserId= localStorage.getItem('UserId')
  function SelectParticular(Id){

    const body =
      {
        
       id:UserId
      }
      console.log('body',body);

    
      axios({
             method:"POST",
             url :`${BASE_URL}/Kdpcorp/GetCorpEditAddUsers`,
             data:body, 
             headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer " + `${token}`,
              }     
          }) 
          
     
          .then((response) =>{
            console.log(response.data);
       
         
                  
            localStorage.setItem("SectionData", JSON.stringify(response.data));
            
         })
         .catch(error => {
           console.log(error);
           
         })
   }


   function getresult(){
    let alldata = localStorage.getItem("Data");
  //console.log(alldata)
  
  
  let namedata =  JSON.parse(alldata);
   //console.log(namedata)
  
  let names = namedata&&namedata.map((item) => item.userName);
     //console.log("username",names)
  
     let UserName= names.toString();
     //console.log(UserName)
  
     let section = namedata&&namedata.map((item) => item.section);
     //console.log('sections',section)
  
     let sectiondata= section.toString();
     //console.log(sectiondata)
  
  let loginUser =localStorage.getItem('username')
  console.log(loginUser)
  
  let Nameresult = UserName.includes(loginUser);  
  console.log(Nameresult)
  
/*---get section data ---*/
  
  
let Usersectiondata =  localStorage.getItem("SectionData");
//console.log(Usersectiondata)


let data =  JSON.parse(Usersectiondata);
 //console.log(data)

let sections = data&&data.map((item) => item.section);
   //console.log(sections)

   let sectionstr = sections.toString();
   console.log(sectionstr);

   localStorage.setItem('corperror',sectionstr)
   

let sectionresult =sectionstr.includes('Life Here')
console.log(sectionresult)
let sectionresultA =sectionstr.includes('Giving Back')
console.log(sectionresultA)
let sectionresultB =sectionstr.includes('Career')
console.log(sectionresultB)
let sectionresultC =sectionstr.includes('Our Team')
console.log(sectionresultC)

let sectionresultF =sectionstr.includes('')
//console.log(sectionresultF)
//let sectionresultF =sectionstr.includes('')


let LoginRoleId= localStorage.getItem("RoleId");
 let CheckAdmin =LoginRoleId.includes("01")


if(sectionresultF==true)
{
  {
    localStorage.getItem('corperror').length==0 ? document.getElementById('corpdisable').innerHTML="Sections not assigned for this User..!": 
    document.getElementById('corpdisable').innerHTML=""
  
  }
}
if(Nameresult==true && sectionresultF==true){
   
  document.getElementById('CorpLableSection').style.display = "inline";

}
else{
   document.getElementById('CorpLableSection').style.display = "inline";
 }

 if(Nameresult==true && sectionresult==true){

  document.getElementById('corp-lableMainA').style.animation = "corppickup1 1.5s 1 forwards";     

  document.getElementById('corp-lableMainA').style.display = "flex"; 
  document.getElementById('corp-lableMainA').style.position="absolute" 
  
 setTimeout(()=>{
  document.getElementById('corp-lableMainA').style.position="static" 
  document.getElementById('corp-touchMainA').style.display = "flex"; 
},1000)
 }
else{
  document.getElementById('corp-touchMainA').style.display = "none"; 
  document.getElementById('corp-lableMainA').style.animation = "corppickup 1.5s 1 forwards";
  document.getElementById('corp-lableMainA').style.display = "none";
 }
 
 if(Nameresult==true && sectionresultA==true){
  
  document.getElementById('corp-lableMainB').style.animation = "corppickup2 1.5s 1 forwards";     

  document.getElementById('corp-lableMainB').style.display = "flex"; 
  document.getElementById('corp-lableMainB').style.position="absolute" 
  
 setTimeout(()=>{
  document.getElementById('corp-lableMainB').style.position="static" 
  document.getElementById('corp-touchMainB').style.display = "flex"; 
},1000)
 }
 else{
  document.getElementById('corp-touchMainB').style.display = "none"; 
  document.getElementById('corp-lableMainB').style.animation = "corppickup 1.5s 1 forwards";
  document.getElementById('corp-lableMainB').style.display = "none";
 }

 if(Nameresult==true && sectionresultB==true){
  
  document.getElementById('corp-lableMainC').style.animation = "corppickup3 1.5s 1 forwards";     

  document.getElementById('corp-lableMainC').style.display = "flex"; 
  document.getElementById('corp-lableMainC').style.position="absolute" 
  
 setTimeout(()=>{
  document.getElementById('corp-lableMainC').style.position="static" 
  document.getElementById('corp-touchMainC').style.display = "flex"; 
},1000)
 }
 else{
  document.getElementById('corp-touchMainC').style.display = "none"; 
  document.getElementById('corp-lableMainC').style.animation = "corppickup 1.5s 1 forwards";
  document.getElementById('corp-lableMainC').style.display = "none";
 }
 if(Nameresult==true && sectionresultC==true){
  
  document.getElementById('corp-lableMainD').style.animation = "corppickup4 1.5s 1 forwards";     

  document.getElementById('corp-lableMainD').style.display = "flex"; 
  document.getElementById('corp-lableMainD').style.position="absolute" 
  
 setTimeout(()=>{
  document.getElementById('corp-lableMainD').style.position="static" 
  document.getElementById('corp-touchMainD').style.display = "flex"; 
},1000)
 }
 else{
  document.getElementById('corp-touchMainD').style.display = "none"; 
  document.getElementById('corp-lableMainD').style.animation = "corppickup 1.5s 1 forwards";
  document.getElementById('corp-lableMainD').style.display = "none";
 }


 if(CheckAdmin==true){


 document.getElementById('CorpLableSection').style.display = "inline";

  document.getElementById('corp-lableMainA').style.animation = "corppickup1 1.5s 1 forwards";     

 document.getElementById('corp-lableMainA').style.display = "flex"; 
 document.getElementById('corp-lableMainA').style.position="absolute" 

 setTimeout(()=>{
  document.getElementById('corp-lableMainA').style.position="static" 
  document.getElementById('corp-touchMainA').style.display = "flex"; 
 },1000)
 

 document.getElementById('corp-lableMainB').style.animation = "corppickup2 1.5s 1 forwards";     

  document.getElementById('corp-lableMainB').style.display = "flex"; 
   document.getElementById('corp-lableMainB').style.position="absolute" 
  
  setTimeout(()=>{
   document.getElementById('corp-lableMainB').style.position="static" 
  document.getElementById('corp-touchMainB').style.display = "flex"; 
 },1000)

  



  document.getElementById('corp-lableMainC').style.animation = "corppickup3 1.5s 1 forwards";     

 document.getElementById('corp-lableMainC').style.display = "flex"; 
  document.getElementById('corp-lableMainC').style.position="absolute" 
 
 setTimeout(()=>{
  document.getElementById('corp-lableMainC').style.position="static" 
  document.getElementById('corp-touchMainC').style.display = "flex"; 
},1000)

 
 

 document.getElementById('corp-lableMainD').style.animation = "corppickup4 1.5s 1 forwards";     

  document.getElementById('corp-lableMainD').style.display = "flex"; 
 document.getElementById('corp-lableMainD').style.position="absolute" 
 
 setTimeout(()=>{
  document.getElementById('corp-lableMainD').style.position="static" 
 document.getElementById('corp-touchMainD').style.display = "flex"; 
 },1000)

 document.getElementById('corpdisable').innerHTML=""

}


 




 
//  if(Nameresult==true && sectionresult==false && sectionresultA==false && sectionresultB==false && sectionresultC==false)
// { 

  
//   document.getElementById("Corp-sectionMainA").innerHTML = " Sections not assigned for this User..!";
//   document.getElementById("Corp-sectionMainA").style.color="red"

// }

}

  

   /*---GetContents----*/

   const[Contenttable, setContenttable] =useState([])

        
   function getContent(){
     const token = JSON.parse(localStorage.getItem('usertoken'));
   
    

     fetch(`${BASE_URL}/Kdpcorp/GetCorpLHContent`, {
       method:'GET',
 
     headers : {
 
       "Content-type": "application/json",
 
       "Accept": "application/json",
 
       "Authorization": "Bearer " +`${token}`,
 
       "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
     },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)

localStorage.setItem("corpLHContentData", JSON.stringify(data));
});


}




function getGBContent(){
  const token = JSON.parse(localStorage.getItem('usertoken'));

 

  fetch(`${BASE_URL}/Kdpcorp/GetCorpGBContent`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

.then(response => response.json())


.then(data => {
console.log("Section",data)

localStorage.setItem("CorpGBContentData", JSON.stringify(data));
});


}





  return (
    <>
    <div id="Corpbg">
    <div className='Corp-addmainPic' >
    <div className='Corp-addmain'>


    

<ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 

{/* <div className="Corp-addgrid-layout">
    <div className="Corp-addmain-top">
        <div className='Corp-addmain-back'>
           <Link to='/kdpcorpdashboard'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Section</span>
 

     </div>
 </div> */}


<span id="corpdisable"></span>

<ul id="CorpLableSection">
<li className="corpdot corpdotty1"id="corp-lableMainA"></li>
  <li className="corpdot corpdotty2" id="corp-lableMainB"></li>
  <li className="corpdot corpdotty3" id="corp-lableMainC"></li>
  <li className="corpdot corpdotty4" id="corp-lableMainD"></li>

</ul>
<ul id='Corp-sectionMainA'>
<li className='corptitle1 corptitle-animate' id="corp-touchMainA"><Link to="/CorpLifehere">Life Here</Link></li>
<li className='corptitle2 corptitle-animate'  id="corp-touchMainB"><Link to="/CorpGivingback">Giving Back</Link></li>
<li className='corptitle3 corptitle-animate'  id="corp-touchMainC"><Link to="/CorpCareer">Career</Link></li>
<li className='corptitle4 corptitle-animate'  id="corp-touchMainD"><Link to="/CorpOurteam">Our Team</Link></li>
</ul>


{/* <div className="holder">

<div className="dot dot1 top "></div>
<div className="dot dot2 mid "> </div>

<div className="dot dot3 btm "></div> 
<div className="dot dot4 udr"></div> 
<ul id='Corp-sectionMainA' className="titles" >

<li id="Corp-touchMainB" >
<nav id="Corp-section-nav">
<label for="Corp-touchB" id="corpsectionlable" >
 &nbsp;<li id ="Corp-sectionB-head" className="title1 title-animate"><Link to="/CorpLifehere">Life Here</Link></li>
</label>               
 <input type="checkbox" id="Corp-touchB" /> 

<ul class="Corp-slide" id="Corp-slideB">

   <ul className='CorpList'> </ul>
</ul>

</nav> 
</li>   

<li  id="Corp-touchMainC">
   <nav id="Corp-section-nav">

<label for="Corp-touchC" id="corpsectionlable">
&nbsp;<li id ="Corp-sectionC-head" className="title2 title-animate" ><Link to="/CorpGivingback">Giving Back</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchC" /> 

<ul class="Corp-slide" id="Corp-slideC">

<ul className='CorpList'>

</ul>
</ul>

</nav> 

</li>
   
<li  id="Corp-touchMainD">
<nav id="Corp-section-nav">

<label for="Corp-touchD" id="corpsectionlable" >
&nbsp;<li id ="Corp-sectionD-head" className="title3 title-animate" ><Link to="/CorpCareer">Career</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchD" /> 

<ul class="Corp-slide" id="Corp-slideD">

<ul className='CorpList'></ul>

</ul>

</nav>

</li>

<li id="Corp-touchMainE">

<nav id="Corp-section-nav">

<label for="Corp-touchE"  id="corpsectionlable">

  
  &nbsp;<li id ="Corp-sectionE-head" className="title4 title-animate"><Link to="/CorpOurteam">Our Team</Link></li>
  </label>               
<input type="checkbox" id="Corp-touchE" /> 

<ul class="Corp-slide" id="Corp-slideE">

<ul className='CorpList'></ul>

</ul>

</nav>
</li>

  </ul>

  </div> */}


 
</div>



    </div>


    {pop? <div id="Loader">

{/* <CircleLoader color="grey" /> */}
<Oval
  height={40}
  width={50}
  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}

    </div>

    </>
  )
}

export default Corpsectionmain
